import React from 'react';

export default function LogoFull({ variant = 'light', height = 42 }) {
  const textColor = variant === 'light' ? '#ffffff' : '#0a1628';
  const iconSize = height;
  const subSize = Math.round(height * 0.18);
  const nameSize = Math.round(height * 0.4);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: Math.round(height * 0.24) }}>
      <svg width={iconSize} height={iconSize} viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="42" height="42" rx="9" fill="#00b4a0" />
        <path
          d="M9 31V11l12 13 12-13v20"
          stroke="#0a1628"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1 }}>
        <span style={{
          fontFamily: "'Syne', sans-serif",
          fontWeight: 800,
          fontSize: nameSize,
          color: textColor,
          letterSpacing: '-0.02em',
          lineHeight: 1.1,
        }}>
          EcoFarm
        </span>
        <span style={{
          fontFamily: "'DM Sans', sans-serif",
          fontWeight: 400,
          fontSize: subSize,
          color: '#00b4a0',
          letterSpacing: '0.12em',
          marginTop: 2,
        }}>
          DEPOZIT FARMACEUTIC
        </span>
      </div>
    </div>
  );
}
